module.exports = __webpack_public_path__ + "img/breed.5529a95b.svg";